import { observer } from 'mobx-react';
import * as React from 'react';
import { Dropdown } from '@shared/ui-react/Dropdown';

@observer
export class VehiclesSortButton extends React.Component<{
    store: {
        sortKey: string;
    };
    btnHollow?: boolean;
}> {
    sortOptions = Object.entries({
        name: kuura.getMessage('general.name'),
        lastReport: kuura.getMessage('js_vehicles.last_contact'),
        vendor: kuura.getMessage('js_vehicles.vendor'),
        type: kuura.getMessage('js_vehicles.type'),
    });

    static defaultProps = {
        btnHollow: false,
    };

    render() {
        const store = this.props.store;
        return (
            <Dropdown closeOnBodyClick={true} className='ik-button-secondary--subtle' tooltip={kuura.getMessage('general.sort')}>
                <i className='iki iki-sort' />
                <ul className='clickable'>
                    {this.sortOptions.map(([key, name]) => (
                        <li onClick={() => this.handleSort(key)} key={key}>
                            <input type='radio' checked={store.sortKey == key} readOnly={true} /> <span>{name}</span>
                        </li>
                    ))}
                </ul>
            </Dropdown>
        );
    }

    handleSort = (key: string) => {
        this.props.store.sortKey = key;
    };
}
